<template>
    <div>
        <sidebar-menu :menu="menu" :collapsed="collapsed" @toggle-collapse="onToggleCollapse" :theme="selectedTheme" :width="width" />
        <main class="main" :class="{'collapsed' : collapsed}">
            <slot></slot>
        </main>
        <div class="payroll-progress-wrapper">
            <div :id="[`payroll-progress-${index}`]" class="payroll-progress-global p-3 text-center card mb-2" v-for="(data, index) in payslip_array" :class="[`payroll-progress-${index}`]" :key="index">
                <button @click="closePayrolWindow(index)" class="btn btn-primary" style="background: transparent !important;"><b-icon icon="x-circle" aria-hidden="true"></b-icon></button>
                <h6 class="progress-company-name">{{data.company_name}}</h6>
                <h6>{{data.month_name}} - {{data.year}}</h6>
                <div v-if="payslip_process">
                    <b-progress :max="data.payslip_count" class="" show-progress animated>
                        <b-progress-bar :value="data.created_payslip_count" :label="'Final Settlement Run In Progress'" v-if="data.run_type == '12'"></b-progress-bar>
                        <b-progress-bar :value="data.created_payslip_count" :label="(data.created_payslip_count)+' / '+(data.payslip_count)" v-else></b-progress-bar>
                    </b-progress>
                    <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                    <h6 class="mb-0 mt-3" v-if="data.run_type == '12'">Final Settlement Run In Progress</h6>
                    <h6 class="mb-0 mt-3" v-else>Total {{data.created_payslip_count}} out of {{data.payslip_count}} payslips processed</h6>
                    </template>
                    <template v-else>
                        <h6 class="mb-0 mt-3">Total {{data.created_payslip_count}} out of {{data.payslip_count}} PF slips processed</h6>
                    </template>
                </div>
                <div v-else>
                    <svg id="m-check-mark" class="custom-success-arrow custom-success-arrow-animation" width="30px" height="30px" viewBox="0 0 245 173" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-opacity="1">
                            <polyline id="checkmark" stroke="rgba(67, 160, 71, 1)" stroke-width="15" points="5.640625 83.7607422 83.2539062 161.663086 238.97168 6.11328125"></polyline>
                        </g>
                    </svg>
                    <svg width="60px" height="60px" style="background: transparent;" id="custom-success-circle-noanimation" class="ml-auto mr-auto d-block mt-1 custom-success-circle">
                        <circle transform="rotate(-90, 95, 95)" class="outer" style="width: 100px;height: auto;" r="25" cx="160" cy="30"></circle>
                    </svg>
                    <h6 class="mb-0 mt-3">Payrun process completed.</h6>
                </div>

            </div>
        </div>

        <div class="import-progress-wrapper">
            <div :id="[`import-progress-${index}`]" class="payroll-progress-global p-3 text-center card mb-2" v-for="(data, index) in import_array" :class="[`import-progress-${index}`]" :key="index">
                <button @click="closePayrolWindowImport(index)" class="btn btn-primary" style="background: transparent !important;"><b-icon icon="x-circle" aria-hidden="true"></b-icon></button>
                <h6 class="progress-company-name" v-if="import_process_text && import_process_text != ''">{{import_process_text}}</h6>
                <h6 class="progress-company-name">{{data.company_name}}</h6>
                <h6 v-if="data.month_name">{{data.month_name}} - {{data.year}}</h6>
                <div v-if="import_process">
                    <template v-if="data.import_completed && data.import_completed.trim() == 'completed'">
                        <b-progress :max="data.total_count" class="" show-progress animated>
                            <b-progress-bar :value="data.current_count" :label="(data.current_count)+' / '+(data.total_count)"></b-progress-bar>
                        </b-progress>
                        <h6 class="mb-0 mt-3">Total {{data.current_count}} out of {{data.total_count}} employee import data processed</h6>
                    </template>
                    <template v-else>
                        <h6 class="mb-0 mt-3">We're getting the data ready for the payrun import process. This may take some time.</h6>
                    </template>
                </div>
                <div v-else>
                    <svg id="m-check-mark-import" class="custom-success-arrow custom-success-arrow-animation-import" width="30px" height="30px" viewBox="0 0 245 173" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-opacity="1">
                            <polyline id="checkmark" stroke="rgba(67, 160, 71, 1)" stroke-width="15" points="5.640625 83.7607422 83.2539062 161.663086 238.97168 6.11328125"></polyline>
                        </g>
                    </svg>
                    <svg width="60px" height="60px" style="background: transparent;" id="custom-success-circle-noanimation-import" class="ml-auto mr-auto d-block mt-1 custom-success-circle-import">
                        <circle transform="rotate(-90, 95, 95)" class="outer" style="width: 100px;height: auto;" r="25" cx="160" cy="30"></circle>
                    </svg>
                    <h6 class="mb-0 mt-3">Payrun import process completed.</h6>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
const separator = {
  template: `<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">`
}
    export default {
        props: [],
        data() {
            return {
                collapsed: false,
                selectedTheme: 'white-theme',
                isOnMobile: false,
                width: '270px',

                menu: [],

                payslip_array: [],
                import_array: [],
                progress_value : 0,
                number_of_employees : 0,
                total_payslips : 0,
                created_payslip_count : 0,
                payslip_process: false,
                import_process: false,
                message: "Payrun calculation in progress for",
                import_process_text: "Payrun Import Process Inprogress",
            }
        },
        methods: {
            onToggleCollapse (collapsed) {
                let customMenuClickVsm = document.querySelector('#custom-menu-btn');
                let dark_mode_container = document.querySelector('#dark-mode-container');
                let navbar_logo = document.querySelector('.navbar-brand');
                navbar_logo.classList.toggle('nav-closed');
                customMenuClickVsm.classList.toggle('sidebar-active');
                customMenuClickVsm.classList.toggle('sidebar-not-active');
                dark_mode_container.classList.toggle('menu-closed');
                dark_mode_container.classList.toggle('menu-opened');
                this.collapsed = collapsed;

                this.$cookies.set("collapsed", collapsed);
            },

            countPayslip: function()
            {
                let currentObj = this;
                let check_payrun = setInterval(() => {
                    axios.get(this.$api_url+'/get-inactive-payrun-payslips', {
                    params: {

                    }
                    }).then(function(response){
                    //console.log(response.data);
                    if(response.data.payslip_count != 0){
                        currentObj.payslip_array = response.data;
                        this.payslip_process = true;
                        //this.message = "Total "+currentObj.progress_value+" out of"+currentObj.total_payslips+" payslips created";
                    }else{
                        clearInterval(check_payrun);
                        this.payslip_process = false;
                        let custom_success_circle = document.getElementById('custom-success-circle-noanimation');
                        if(custom_success_circle){
                            custom_success_circle.classList.add('custom-success-circle');
                        }
                        let custom_success_arrow = document.getElementById('m-check-mark');
                        if(custom_success_arrow){
                            custom_success_arrow.classList.add('custom-success-arrow-animation');
                        }
                    }

                    }.bind(this)).catch(function (error){ currentObj.output = error;});
                }, 3000);
                this.payslip_process = false;
            },

            countImportProgress: function()
            {
                let currentObj = this;
                let check_payrun = setInterval(() => {
                    axios.get(this.$api_url+'/read-import-progress-file', {
                    params: {

                    }
                    }).then(function(response){
                    //console.log(response.data);
                    let body_class_import = document.getElementById('dombody');
                    if(response.data.process_count != 0){
                        currentObj.import_array = response.data;
                        console.log(currentObj.import_array.import_completed);
                        this.import_process = true;
                        if(body_class_import){
                            body_class_import.classList.remove('import-inprogress');
                            body_class_import.classList.add('import-inprogress');
                        }
                        currentObj.import_process_text = 'Payrun Import Process Inprogress';
                        //this.message = "Total "+currentObj.progress_value+" out of"+currentObj.total_payslips+" payslips created";
                    }else{
                        clearInterval(check_payrun);
                        this.import_process = false;
                        let custom_success_circle_import = document.getElementById('custom-success-circle-noanimation-import');
                        if(custom_success_circle_import){
                            custom_success_circle_import.classList.add('custom-success-circle-import');
                        }
                        let custom_success_arrow_import = document.getElementById('m-check-mark-import');
                        if(custom_success_arrow_import){
                            custom_success_arrow_import.classList.add('custom-success-arrow-animation-import');
                        }
                        if(body_class_import){
                            body_class_import.classList.remove('import-inprogress');
                        }
                        currentObj.import_process_text = '';
                    }

                    }.bind(this)).catch(function (error){ currentObj.output = error;});
                }, 3000);
                this.import_process = false;
            },

            closePayrolWindow: function(index)
            {
                document.getElementById("payroll-progress-"+index).remove();
            },

            closePayrolWindowImport: function(index)
            {
                document.getElementById("import-progress-"+index).remove();
            },

            getMenu: function() {

                axios.get(this.$api_url+'/menu',{
                 params: {

                 }
              }).then(function(response){

                    this.menu = response.data;
                }.bind(this));
            },
        },
        created: function(){
            this.getMenu();
            this.countPayslip();
            this.countImportProgress();
        },
    }
</script>

<style >

/* added by faroque */
.v-sidebar-menu img.vsm--icon{width: auto !important; height: auto !important; background-color: transparent !important;}
.v-sidebar-menu img.vsm--icon.atlhrlogo {
	width: 20px !important;
	margin-left: 5px;
	margin-right: 15px;
}
/*************** */


.vsm--item.vsm--item_open {
	border: 1px solid #464D5C;
	border-radius: 5px;
}

.main {
    padding-left: 270px;
    transition: 0.5s ease;
}
.main.collapsed {
    padding-left: 50px;
}
.v-sidebar-menu .vsm--mobile-item {background:#01524B!important;}
.v-sidebar-menu .vsm--mobile-item .vsm--item.vsm--item_open {width: 100%; margin: 0; }
.v-sidebar-menu .vsm--mobile-item .vsm--item.vsm--item_open > .vsm--link {border-bottom: none;}
.v-sidebar-menu .vsm--mobile-bg {background:#01524B !important;}
.v-sidebar-menu .vsm--toggle-btn {background:#34444c !important; display: none;}
.v-sidebar-menu .vsm--link.vsm--link_mobile-item {background:#A4E1DB !important;}
.v-sidebar-menu .vsm--link_hover, .v-sidebar-menu .vsm--link:hover {background-color: transparent;}
.v-sidebar-menu .vsm--mobile-item > .vsm--item > .vsm--link{
    line-height: 18px !important;
}
.v-sidebar-menu.vsm_collapsed .vsm--item {
	border: none;
	margin: 0;
}
.v-sidebar-menu.vsm_collapsed .vsm--mobile-item .vsm--dropdown {
	border-right: 1px solid #464D5C;
	border-bottom: 1px solid #464D5C;
    border-bottom-right-radius: 0.25rem;
    padding-left: 15px;
    background:#3d4c34;
}
.v-sidebar-menu.vsm_collapsed .vsm--mobile-item > .vsm--item > .vsm--link {
	border-right: 1px solid #464D5C;
	border-top: 1px solid #464D5C;
    border-radius: 0;
    border-top-right-radius: 0.25rem;
    margin-left: -1px !important;
    padding-left: 15px;
}
#custom-menu-btn {
	border: none;
	background: transparent;
    padding: 0;
    margin-left: -8px;
    outline: none;
    width: 30px;
}

#custom-menu-btn.sidebar-not-active .menu-close {display: none;}
#custom-menu-btn.sidebar-active .menu-close {display: inline-block;}
#custom-menu-btn.sidebar-active .menu-open {display: none;}
#custom-menu-btn.sidebar-not-active .menu-open {display: inline-block;}

.v-sidebar-menu.vsm_white-theme {
    background-color: #01524B !important;
}
.v-sidebar-menu{
    border-right: 1px solid rgba(0, 0, 0, 0.125);
}
.v-sidebar-menu .vsm--item{white-space: unset !important;}
.v-sidebar-menu .vsm--mobile-item .vsm--arrow{position: absolute; right: 0;}
.v-sidebar-menu.vsm_white-theme .vsm--link_hover, .v-sidebar-menu.vsm_white-theme .vsm--link:hover {
	background-color: transparent;
    color: #fff !important;
}
.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_exact-active, .v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_active {
	-webkit-box-shadow: unset;
	box-shadow: unset;
}

/*******for dark mode******** */
.v-sidebar-menu{
    /*background-color: #f8fafc;
    border-right: 1px solid #464D5C;*/
}
body.dark-mode-enabled .v-sidebar-menu {
	background-color: #001C38 !important;
    border-right: 1px solid #464D5C;
}
.dark-mode-enabled .v-sidebar-menu .vsm--mobile-item {background:#293557 !important;}
.dark-mode-enabled .v-sidebar-menu .vsm--mobile-bg {background:#293557 !important;}
.dark-mode-enabled .v-sidebar-menu .vsm--link.vsm--link_mobile-item {background:#293557 !important;}
/********for dark mode******* */


</style>
